import { DialogType } from '@/enums/dialogType'
import api from '@/services/api'

export default {
    namespaced: true,
    state: {
        transfer: {},
        lstTransfer: [],
        lstTransferItems: [],
        isUpdate: false,
        shouldReload: false,
        search: "",
        itemsPerPage: 25,
        hasNext: false,
        page: 1,
        totalItems: 0,
        headers: [
            { title: 'Transferência', key: 'transferId', align: 'center' },
            { title: 'Data', key: 'transferDate', align: 'center' },
            { title: 'Estoque origem', key: 'originStockName', align: 'center' },
            { title: 'Estoque destino', key: 'destinationStockName', align: 'center' },
        ],
        headersItems: [
            { title: 'ID Produto', key: 'productId', align: 'center' },
            { title: 'Produto', key: 'productName', align: 'center' },
            { title: 'Quantidade', key: 'quantity', align: 'center' },
            { title: '', key: 'actions', align: 'center' }
        ],
    },
    getters: {
        getTransfer(state) {
            let transfer = { ...state.transfer, transferItems: state.lstTransferItems }
            return transfer
        }
    },
    mutations: {
        setTransfer(state, transfer) {
            state.transfer = transfer
        },
        setLstTransfer(state, lstTransfer) {
            state.lstTransfer = lstTransfer
        },
        setLstTransferItems(state, lstTransferItems) {
            state.lstTransferItems = lstTransferItems
        },
        appendLstTransfer(state, items) {
            state.lstTransfer = [...state.lstTransfer, ...items]
        },
        clearLstTransfer(state) {
            state.lstTransfer = []
        },
        setPage(state, page) {
            state.page = page
        },
        setHasNext(state, hasNext) {
            state.hasNext = hasNext
        },
        setTotalItems(state, total) {
            state.totalItems = total
        },
        setShouldReload(state, reload) {
            state.shouldReload = reload
        },
        initForm(state) {
            state.isUpdate = false
            state.transfer = {}
            state.lstTransferItems = []
            state.search = ''
        },
        setUpdating(state) {
            state.isUpdate = true
        }
    },
    actions: {
        async save({ state, dispatch }) {
            if (state.isUpdate) {
                return await dispatch('update')
            }
            else
                return await dispatch('insert')
        },

        async insert({ getters, dispatch }) {
            await api.post(
                '/StockTransfer/Insert',
                getters.getTransfer
            )

            dispatch('systemDialog/show', {
                type: DialogType.SUCCESS,
                message: 'Transferência salva'
            }, { root: true })

            return true
        },

        async update({ getters, dispatch }) {
            await api.put(
                '/StockTransfer/Update',
                getters.getTransfer
            )

            dispatch('systemDialog/show', {
                type: DialogType.SUCCESS,
                message: 'Transferência atualizado'
            }, { root: true })

            return true
        },

        async search({ state, commit }, { search, limit = 25, page = 1, reset}) {
            let searchParam = search || state.search
            const response = await api.get(
                `/StockTransfer/Search?search=${searchParam}&limit=${limit}&page=${page}`
            )

            if (reset) {
                commit("setLstTransfer", response.data.items)
            } else {
                commit("appendLstTransfer", response.data.items)
            }

            commit('setHasNext', response.data.hasNext)
            commit('setTotalItems', response.data.totalCount)
            commit('setPage', page)

            return true
        },

        async find({commit}, transferId) {
            const response = await api.get(
                `/StockTransfer/Find/${transferId}`,
            )

            commit('setTransfer', response.data)
            commit('setUpdating')

            return true
        },

        async findList({commit}, transferId) {
            const response = await api.get(
                `/StockTransfer/FindList/${transferId}`,
            )
            commit('setLstTransferItems', response.data)

            return true
        },

        async delete({ getters, dispatch }) {
            await api.delete(
                `/StockTransfer/Delete/${getters.getTransfer.transferId}`,
            )
            dispatch('systemDialog/show', {
                type: DialogType.SUCCESS,
                message: 'Registro deletado com sucesso!'
            }, { root: true })

            return true
        }
    }
}